// Could be expanded - log in which stages ? dev / test / prod, etc...
export const devLogger = (...args: unknown[]): void => {
  if (process.env.NODE_ENV === 'development') {
    console.log(...args);
  }
};
